import RevenueStat from './RevenueStat';

export default RevenueStat;
